﻿

// ------------------------------------------------------------------------- //
// #CONTACT
// ------------------------------------------------------------------------- //


window.farmday = window.farmday || {};
farmday.modules = farmday.modules || {};


farmday.modules.contact = (function () {
    var priv = {};


    /**
     * Private initialization method
     */
    priv.init = function () {

        if ($(".js-page-identifier-contact").length) {
            document.addEventListener("invalid", (function () {
                return function (e) {
                    //e.preventDefault();
                    document.getElementById("query").focus();
                };
            })(), true);

            var siteUserName = document.getElementById("siteUserId").value;
            if (!siteUserName || siteUserName.trim().length === 0) {
                return;
            }

            $(".workshop-star").click(function (event) {
                if (!siteUserName || !siteUserName.trim()) {
                    return;
                }

                $("section.lm__contents").addClass("inactive-view");
                $.ajax({
                    type: "POST",
                    url: "/api/workshop/setstar",
                    data: {
                        city: event.target.dataset.city,
                        newStarValue: event.target.dataset.star === "True" ? "False" : "True"
                    },
                    dataType: "json",
                    cache: false,
                    success: function () {
                        $(".marked").toggleClass("marked");
                        $(event.target).toggleClass("marked");
                    }
                }).fail(function () {
                    location.reload();
                }).always(function () {
                    $("section.lm__contents").removeClass("inactive-view");
                });
            });
        }
    };


    // Initialize module
    $(function () {
        priv.init();
    });

})();
